<template>
    <div>
        <div class="vx-row">
            <div class="vx-col w-full md:w-1/2 mb-base">
                <vx-card :title="user.userRole.charAt(0).toUpperCase() + user.userRole.slice(1) ">
                    <div slot="no-body">
                        <div class="vx-row">
                            <div class="vx-col w-full flex flex-col justify-between mb-3 pb-6">
                                <div class="lg:ml-6 lg:mt-6 md:mt-0 md:ml-0 sm:ml-6 sm:mt-6">
                                    <div class="flex">
                                        <div class="mr-2">
                                            <vs-avatar v-if="user" :text="user.displayName" size="85px"
                                                       class="user-avatar"/>
                                        </div>
                                        <div class="ml-6">
                                            <div class="user-info">
                                                <span class="data-label">Name</span>
                                                <span class="ml-4" v-if="user">{{ user.displayName }}</span>
                                            </div>
                                            <div class="user-info">
                                                <span class="data-label">Referral ID</span>
                                                <span class="ml-4" v-if="user">{{ user.uid }}</span>
                                            </div>
                                            <div class="user-info">
                                                <span class="data-label">Email</span>
                                                <span class="ml-4" v-if="user">{{ user.email }}</span>
                                            </div>
                                            <div>
                                                <a :href="profileUrl">
                                                    View user's profile
                                                </a>
                                            </div>
                                            <div>
                                                <a v-clipboard:copy="referralLink" v-clipboard:success="onCopy"
                                                   v-clipboard:error="onError" class="cursor-pointer">
                                                    <feather-icon icon="ClipboardIcon" svgClasses="w-4 h-4"/>
                                                    Copy referral link to clipboard
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </vx-card>
            </div>

            <div class="vx-col w-full md:w-1/2 mb-base" v-if="user.userRole === Role.User">
                <vx-card title="Sponsor">
                    <div slot="no-body">
                        <div class="vx-row">
                            <div class="vx-col w-full flex flex-col justify-between mb-3 pb-6">
                                <div class="lg:ml-6 lg:mt-6 md:mt-0 md:ml-0 sm:ml-6 sm:mt-6">
                                    <div class="flex">
                                        <div class="mr-2">
                                            <vs-avatar v-if="sponsor"
                                                       :text="sponsor.first_name + ' ' + sponsor.last_name" size="85px"
                                                       class="user-avatar"/>
                                        </div>
                                        <div class="ml-6">
                                            <div class="user-info name">
                                                <span class="data-label">Name</span>
                                                <span class="ml-4"
                                                      v-if="sponsor">{{ sponsor.first_name }} {{
                                                        sponsor.last_name
                                                    }}</span>
                                            </div>
                                            <div class="user-info email">
                                                <span class="data-label">Email</span>
                                                <span class="ml-4" v-if="sponsor">{{ sponsor.email }}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </vx-card>
            </div>
        </div>

        <div class="vx-row" v-if="user.userRole === Role.User">
            <div class="vx-col w-full md:w-1/2 mb-base">
                <statistics-card-line
                    :icon="membership.valid ? 'CheckIcon' : 'XIcon'"
                    :iconRight=false
                    :statistic="membership.valid ? 'ACTIVE (' + membership.days + ' days left)' : 'NOT ACTIVE'"
                    statisticTitle="Membership"
                    :color="membership.valid ? 'success' : 'danger'"
                    colorTo="danger"
                    type="line"></statistics-card-line>
            </div>
        </div>
    </div>
</template>

<script>
import RestService from '../services/RestService';
import StatisticsCardLine from '../components/statistics-cards/StatisticsCardLine';
import {Role} from '../enums/role';
import keycloak from '../services/KeycloakService';

export default {
    name: 'profile',
    components: {StatisticsCardLine},
    async beforeCreate() {
        if (this.$store.state.AppActiveUser.userRole === Role.User) {
            const sponsorResponse = await RestService.getUsersReferrer();
            if (sponsorResponse.success)
                this.sponsor = sponsorResponse.data;
        }
    },
    data() {
        return {
            user: this.$store.state.AppActiveUser,
            sponsor: null,
            membership: this.$store.state.AppActiveUser.membership,
            Role: Role,
            profileUrl: keycloak.getUserProfileUrl(),
            referralLink: 'https://elitetradingfx.com/?ref=' + this.$store.state.AppActiveUser.uid
        }
    },
    methods: {
        onCopy: function (e) {
            this.$vs.notify({
                color: 'primary',
                title: 'Referral link successfully copied to clipboard.',
                text: e.text,
                position: 'top-center'
            });
        },
        onError: function () {
            this.$vs.notify({
                color: 'danger',
                title: 'Failed to copy referral link to clipboard.',
                text: 'Please try again.',
                position: 'top-center'
            });
        }
    }
}
</script>

<style lang="scss">
.user-info {
    margin: 10px 0;

    &.name {
        margin-top: 20px;
    }

    &.email {
        margin-bottom: 52px;
    }

    .data-label {
        font-weight: bold;
    }
}

.user-avatar {
    font-size: 50px;
}

.cursor-pointer {
    cursor: pointer;
}
</style>
